import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowRightIcon, BellPlusIcon, CheckIcon, ChevronRightIcon, HeartIcon, MapPinIcon, PawPrintIcon } from 'lucide-react';
import { PetCard } from '../components/animaux/PetCard';
import { LostFlow } from '../components/animaux/LostFlow';
import { PetRules } from '../components/animaux/PetAtna';
import { VetConnect } from '../components/animaux/VetConnect';
import { petReminders, petTodos, pets, sightings, sourceLabels } from '../data/animaux';
export function AnimalDetail() {
  const {
    id
  } = useParams();
  const pet = pets.find(item => item.id === id) ?? pets[0];
  const [lost, setLost] = useState(false);
  const [flowOpen, setFlowOpen] = useState(false);
  const [found, setFound] = useState(false);
  const todos = petTodos[pet.id] ?? [];
  const reminders = petReminders[pet.id] ?? [];
  return <main className="bg-white" data-id="element-2731" data-mp="1ezt7b0gxcozy">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2732" data-mp="1eyrjrwiq2a1c">
        <nav aria-label="Fil d’Ariane" className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500" data-id="element-2733" data-mp="2jm5tikwt2zyt">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2734" data-mp="2emkl7jvqxf9f">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2735" data-mp="2tkd1ie94a7oo" />
          <Link to="/mes-animaux" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2736" data-mp="2oliet1813yza">
            Mes animaux
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2737" data-mp="20u3ch8g95ho1" />
          <span aria-current="page" data-id="element-2738" data-mp="1vyflqom4gggf">{pet.name}</span>
        </nav>

        <div className="mt-6 grid gap-10 lg:grid-cols-[minmax(0,520px)_minmax(0,1fr)] lg:gap-12" data-id="element-2739" data-mp="2amito3jq627v">
          <div data-id="element-2740" data-mp="25ur0rmd3jkek">
            <PetCard pet={pet} lost={lost} data-id="element-2741" data-mp="25v0vfn936fql" />

            {!lost ? <button type="button" onClick={() => setFlowOpen(true)} className="mt-3 inline-flex items-center gap-2 rounded-full border border-slate-200 px-5 py-2.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-red-600 hover:text-red-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2742" data-mp="1i5g86s5wgwbi">
                <PawPrintIcon className="h-4 w-4" aria-hidden="true" data-id="element-2743" data-mp="2bmss3kb4q7xi" />
                Déclarer {pet.name} perdu
              </button> : <button type="button" onClick={() => {
            setLost(false);
            setFound(true);
          }} className="mt-3 inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-2744" data-mp="2go9q9828bgae">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-2745" data-mp="34bhxhvj7wzf2" />
                {pet.name} est retrouvé
              </button>}
          </div>

          <div data-id="element-2746" data-mp="xnqzqyy2h1n7">
            {found && <div className="mb-6 flex items-start gap-3 rounded-2xl bg-ville-indigo-soft px-5 py-4" data-id="element-2747" data-mp="xmpmcntkw32b">
                <HeartIcon className="mt-0.5 h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-2748" data-mp="sqhdtt9vz844" />
                <div data-id="element-2749" data-mp="nvl7rp7tek80">
                  <p className="font-bold text-ville-navy" data-id="element-2750" data-mp="iyl6rspto7nr">{pet.name} est retrouvé</p>
                  <p className="text-sm text-slate-600" data-id="element-2751" data-mp="iwqqwster5qj">
                    L’alerte communautaire a été fermée. Merci aux citoyens qui ont aidé.
                  </p>
                </div>
              </div>}

            {lost && <section aria-labelledby="perdu-titre" className="mb-8 overflow-hidden rounded-3xl border border-slate-200" data-id="element-2752" data-mp="4zv47xk8hfs0">
                <div className="border-l-4 border-red-600 p-6" data-id="element-2753" data-mp="1jwbsdi1fcf">
                  <span className="inline-flex rounded-full bg-red-600 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white" data-id="element-2754" data-mp="1zd36gaajgtno">
                    Perdu
                  </span>
                  <h2 id="perdu-titre" className="mt-3 text-xl font-extrabold text-ville-navy" data-id="element-2755" data-mp="22dwlghafbo2f">
                    {pet.name} est actuellement déclaré perdu.
                  </h2>
                  <p className="mt-1 text-sm text-slate-600" data-id="element-2756" data-mp="1sg9yr8mvus7w">
                    Avis communautaire envoyé · rayon de 1,5 km · aucune donnée personnelle partagée.
                  </p>

                  <div className="relative mt-5 h-40 overflow-hidden rounded-2xl bg-slate-100" data-id="element-2757" data-mp="1xh65dtymcsh0">
                    <div className="absolute inset-0 opacity-60 [background-image:linear-gradient(#cbd5e1_1px,transparent_1px),linear-gradient(90deg,#cbd5e1_1px,transparent_1px)] [background-size:28px_28px]" data-id="element-2758" data-mp="1jm3okbs8hipf" />
                    <div className="absolute left-1/2 top-1/2 h-28 w-28 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-ville-indigo bg-ville-indigo/10" data-id="element-2759" data-mp="1eov76dewtip8" />
                    <span className="absolute left-1/2 top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-ville-indigo" data-id="element-2760" data-mp="10pvrhv9dke57" />
                  </div>
                  <p className="mt-2 text-xs text-slate-500" data-id="element-2761" data-mp="m1lrln64nnt1">
                    Dernier endroit connu et zone de recherche — il ne s’agit pas de la position actuelle de {pet.name}.
                  </p>

                  <h3 className="mt-6 text-sm font-bold uppercase tracking-wider text-slate-500" data-id="element-2762" data-mp="v44olqn8f67d">Signalements récents</h3>
                  <ol className="mt-3 space-y-3" data-id="element-2763" data-mp="q2ffigjkl2lx">
                    {sightings.map(sighting => <li key={sighting.time} className="flex gap-3 text-sm" data-id="element-2764" data-mp="14zetcm50lrou">
                        <span className="w-16 shrink-0 font-semibold text-slate-500" data-id="element-2765" data-mp="101d9hyzrlocb">{sighting.time}</span>
                        <span data-id="element-2766" data-mp="1dt1l8163qasr">
                          <span className="block font-bold text-ville-navy" data-id="element-2767" data-mp="1dve1m9w7od3p">{sighting.label}</span>
                          <span className="flex items-center gap-1 text-slate-500" data-id="element-2768" data-mp="19ubz9k6zzkxi">
                            <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-2769" data-mp="1ns0nn209xa7b" />
                            {sighting.place}
                          </span>
                        </span>
                      </li>)}
                  </ol>
                </div>
              </section>}

            <section aria-labelledby="detail-a-faire" data-id="element-2770" data-mp="pfwmqmegaj7i">
              <h2 id="detail-a-faire" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-2771" data-mp="pf4rxdsogpia">
                À faire
              </h2>
              {todos.length === 0 ? <p className="mt-2 flex items-center gap-2 text-sm text-slate-500" data-id="element-2772" data-mp="z4obyms4mpeq">
                  <CheckIcon className="h-4 w-4 text-ville-indigo" aria-hidden="true" data-id="element-2773" data-mp="14418jz8svaui" />
                  Tout est à jour.
                </p> : <ul className="mt-4 space-y-3" data-id="element-2774" data-mp="184l5b1pgocg4">
                  {todos.map(todo => <li key={todo.id} className="rounded-2xl border border-slate-200 px-5 py-4" data-id="element-2775" data-mp="1d3eg2mdd5pcl">
                      <p className="text-[15px] font-bold text-ville-navy" data-id="element-2776" data-mp="39zvkdmw141jx">{todo.title}</p>
                      <p className="mt-0.5 text-sm text-slate-600" data-id="element-2777" data-mp="3ex3z1dhyxngf">{todo.detail}</p>
                      <button type="button" className="mt-3 inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-2778" data-mp="37exg5r2vhp6r">
                        {todo.cta}
                        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2779" data-mp="3q9ukd2ttr6en" />
                      </button>
                    </li>)}
                </ul>}
            </section>

            <section aria-labelledby="rappels-titre" className="mt-10" data-id="element-2780" data-mp="3ccpk5jgsl1rb">
              <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-2781" data-mp="3ceiga4ts43l2">
                <h2 id="rappels-titre" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-2782" data-mp="25070prz9nfta">
                  Rappels
                </h2>
                <button type="button" className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2783" data-mp="3w4sa32vubjc">
                  <BellPlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-2784" data-mp="nklw61otbgsg" />
                  Ajouter un rappel
                </button>
              </div>
              <ul className="mt-4 space-y-2" data-id="element-2785" data-mp="rkxkppkaq197">
                {reminders.map(reminder => <li key={reminder.id} className="flex flex-wrap items-baseline justify-between gap-2 rounded-2xl bg-slate-50 px-5 py-3" data-id="element-2786" data-mp="du13svzqf8hz">
                    <span data-id="element-2787" data-mp="irkh9tolvh8v">
                      <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2788" data-mp="16iy81v73z4rq">{reminder.label}</span>
                      <span className="block text-xs text-slate-500" data-id="element-2789" data-mp="1bag8mi57z3c6">{sourceLabels[reminder.source]}</span>
                    </span>
                    <span className="text-sm text-slate-600" data-id="element-2790" data-mp="1kngo0taod78p">{reminder.date}</span>
                  </li>)}
              </ul>
              <p className="mt-3 text-xs text-slate-500" data-id="element-2791" data-mp="1uejru2uzo0bo">
                Les rappels et changements apparaissent dans{' '}
                <Link to="/notifications" className="font-bold text-ville-indigo hover:underline" data-id="element-2792" data-mp="1pfgm0g76pq2n">
                  Notifications
                </Link>
                . La facture de renouvellement est déposée dans{' '}
                <Link to="/mon-profil" className="font-bold text-ville-indigo hover:underline" data-id="element-2793" data-mp="xq52x2zm70c6">
                  Mon profil → Mes factures
                </Link>
                .
              </p>
            </section>
          </div>
        </div>

        <PetRules data-id="element-2794" data-mp="2n3ie9c659oms" />
        <VetConnect data-id="element-2795" data-mp="2n2pdcrtv9tck" />
      </div>

      <LostFlow pet={pet} open={flowOpen} onClose={() => setFlowOpen(false)} onConfirm={() => {
      setFlowOpen(false);
      setLost(true);
      setFound(false);
    }} data-id="element-2796" data-mp="2n1xhrh09rvma" />
    </main>;
}